export default {
  dbi_filterSave_filter_setting: `Save Filter Setting`,
  dbi_filterSave_setting_info: `Saved setting can be used in all filters in Intelligence`,
  dbi_filterSave_setting_name: `Setting Name`,
  dbi_filterSave_input_maximum: `A maximum of {max} characters are supported`,
  dbi_filterSave_save_item: `Items to be saved`,
  dbi_filterSave_replace_setting: `A setting with the same name already exists, click save to replace this setting.`,
  dbi_filterSave_enter_a_name: `Please enter a name`,
  dbi_filterSave_my_filter: `My Filter`,
  dbi_filterSave_my_filter_nodata: `No filter available`,
  dbi_filterSave_my_filter_search: `Search your Filter`,
  dbi_filterSave_my_filter_top10: `Up to 10 settings can be saved`,
  dbi_filterSave_delete_info: `Delete the filter setting`,
  dbi_filterSave_do_delete: `Do you want to delete ?`,
  dbi_filterSave_successful_operation: `Successful Operation`,
  dbi_filterSave_operation_failure: `Operation Failure`,
  dbi_filterSave_icon_delect: `Delete`,
  dbi_filterSave_duration: `Duration`,
  dbi_filterSave_release: `Release`,
  dbi_filterSave_none: `None`,
};
